(function(){
  /* SOM buy box helpers.
     1) marks the chosen size pill in the Profit Pumper pack chooser
     2) relabels the pack price ("/each" vs pack total)
     3) makes the size pills keyboard operable and readable by screen readers
     4) swaddle blanket: skips the hidden Single pack
     The apps themselves are never modified, only classes, one label and ARIA. */

  var SEL = '#prvw__bundle_container';
  var SEL9 = '#pumper_bundle_svelte';   /* the app's new (Svelte) widget */
  var SWADDLE = '.product-form[data-product-id="8162397749341"]';

  /* ---------- pack price label ---------- */

  function qtyOf(w){
    var h5 = w.querySelector('.template_4_block__cbmain--content--left__top h5');
    var t  = h5 ? h5.textContent.trim() : '';
    var m  = t.match(/(\d+)\s*pack/i);
    return m ? parseInt(m[1],10) : 1;
  }

  function amountOf(w){
    var a = w.querySelector('.prvw_totalAmount_wrapper h4');
    if(!a) return null;
    var txt = a.textContent.trim();
    var val = parseFloat(txt.replace(/[^0-9.]/g,''));
    return isFinite(val) ? { val:val, sym:(txt.match(/^[^0-9]*/)||[''])[0] } : null;
  }

  function money(sym, n){
    var s = (Math.round(n*100)/100).toFixed(2);
    if(s.slice(-3) === '.00') s = s.slice(0,-3);
    return sym + s;
  }

  function singlePrice(wraps){
    var i, j;
    for(i=0;i<wraps.length;i++){
      if(qtyOf(wraps[i]) === 1){
        var a = amountOf(wraps[i]);
        if(a) return a.val;
      }
    }
    for(j=0;j<wraps.length;j++){
      var p = wraps[j].querySelector('.template_4_prevprice');
      if(p){
        var v = parseFloat(p.textContent.replace(/[^0-9.]/g,''));
        if(isFinite(v) && v > 0) return v;
      }
    }
    return null;
  }

  /* ---------- size pills ---------- */

  function pillsOf(m){
    return [].slice.call(m.querySelectorAll('.custom_variant_select_options_list > div'));
  }

  function chosenValue(m){
    var d = m.querySelector('.variant-display-value');
    return d ? d.textContent.trim() : '';
  }

  function markPills(){
    document.querySelectorAll(SEL + ' .custom_variant_select_wrapper_main').forEach(function(m){
      var v = chosenValue(m);
      var list = m.querySelector('.custom_variant_select_options_list');
      if(list && list.getAttribute('role') !== 'radiogroup'){
        list.setAttribute('role','radiogroup');
        if(!list.getAttribute('aria-label')) list.setAttribute('aria-label','Size');
      }
      pillsOf(m).forEach(function(o){
        var on = o.textContent.trim() === v;
        o.classList.toggle('som-sel', on);
        if(o.getAttribute('role') !== 'radio'){
          o.setAttribute('role','radio');
          o.setAttribute('tabindex','0');
        }
        if(o.getAttribute('aria-checked') !== String(on)) o.setAttribute('aria-checked', String(on));
      });
    });
  }

  /* Enter and Space activate a pill, arrow keys move between them.
     Delegated once on the container so re-rendered pills stay covered. */
  /* Paint the chosen size pill the instant it is tapped.
     Measured on the live sack: the app's own label updates 22ms after the tap, but the navy
     selected state is ours and was only applied when the debounced MutationObserver fired,
     which is 80ms after the DOM stops changing - about 105ms on a quiet click and longer
     whenever the app's price update keeps resetting the debounce. The Baby PJs felt instant
     by comparison because there the highlight is the app's own class, set synchronously.
     Capture phase, so this runs before the app's inline onclick. markPills() reconciles
     afterwards, so a click the app rejects self-corrects within one tick. */
  function wireInstantPaint(c){
    c.addEventListener('click', function(e){
      var o = e.target.closest && e.target.closest('.custom_variant_select_options_list > div');
      if(!o || !o.parentElement) return;
      [].slice.call(o.parentElement.children).forEach(function(x){
        var on = (x === o);
        x.classList.toggle('som-sel', on);
        if(x.getAttribute('aria-checked') !== null) x.setAttribute('aria-checked', String(on));
      });
    }, true);
  }

  function wireKeys(c){
    c.addEventListener('keydown', function(e){
      var o = e.target.closest && e.target.closest('.custom_variant_select_options_list > div');
      if(!o) return;
      var key = e.key;
      if(key === 'Enter' || key === ' ' || key === 'Spacebar'){
        e.preventDefault();
        o.click();
        return;
      }
      var next = null;
      if(key === 'ArrowRight' || key === 'ArrowDown') next = o.nextElementSibling;
      if(key === 'ArrowLeft'  || key === 'ArrowUp')   next = o.previousElementSibling;
      if(next){
        e.preventDefault();
        next.focus();
        next.click();
      }
    });
  }

  function mark(){
    markPills();

    var wraps = [].slice.call(document.querySelectorAll(SEL + ' .template_4_block_wrapper'));
    if(!wraps.length) return;
    var one = singlePrice(wraps);

    wraps.forEach(function(w){
      var lab = w.querySelector('.prvw_each_price_text');
      if(!lab) return;
      var qty = qtyOf(w);
      var a   = amountOf(w);
      var want = '';

      var note = '';

      if(qty > 1 && a){
        if(one && a.val > one * 1.05){
          /* the app is showing the pack total */
          want = 'total';
          note = money(a.sym, a.val / qty) + ' each';
        } else {
          want = '/each';
          note = money(a.sym, a.val * qty) + ' total';
        }
      } else if(qty > 1){
        want = '/each';
      }

      if(lab.textContent.trim() !== want){ lab.textContent = want; }
      lab.style.visibility = want ? '' : 'hidden';

      /* the second figure goes on its own line so it can never shift the amount
         out of line with the other packs */
      var right = w.querySelector('.template_4_block__cbmain--content--right');
      var el = w.querySelector('.som-each-note');
      var checked = !!w.querySelector('input.prvw_pair:checked');
      if(right && note && checked){
        if(!el){
          el = document.createElement('span');
          el.className = 'som-each-note';
          right.appendChild(el);
        }
        if(el.textContent !== note) el.textContent = note;
      } else if(el){
        el.remove();
      }
    });
  }

  /* ---------- swaddle blanket: Single pack is hidden, never leave it selected ---------- */

  function skipSingle(){
    var form = document.querySelector(SWADDLE);
    if(!form) return;
    var single = form.querySelector('.option-selector__btns .opt-btn[value="Single"]');
    if(!single || !single.checked) return;
    var next = form.querySelector('.option-selector__btns .opt-btn[value="2 Pack"]')
            || form.querySelector('.option-selector__btns .opt-btn[value="3 Pack"]');
    if(!next) return;
    var label = next.nextElementSibling;
    if(label && label.classList.contains('opt-label')){ label.click(); }
    else { next.checked = true; next.dispatchEvent(new Event('change',{bubbles:true})); }
  }

  /* ---------- consistent placement across products ---------- */

  /* The shipping line and the bundle upsell land in different places on different
     products because each template puts its blocks in a different order and the
     upsell app injects itself into the buy button area when the template gives it
     no anchor. These two put them in the same place on every product:
       pack chooser -> Free shipping and free returns -> Add to cart
       ... Add to cart ... -> trust line -> bundle upsell */
  function placeBlocks(){
    document.querySelectorAll('.product-form').forEach(function(pf){
      var bb = pf.querySelector(':scope > .buy-buttons-row');
      if(!bb) return;
      var form = bb.querySelector('form.js-product-form');

      /* shipping line goes directly above Add to cart */
      var box = pf.querySelector('.product-info-block.with-icon.text-box');
      if(box && form){
        var row = box.closest('.lightly-spaced-row');
        if(row && !(row.parentElement === bb && row.nextElementSibling === form)){
          bb.insertBefore(row, form);
        }
      }

      /* bundle upsell goes below the trust line, out of the buy button area */
      var ups = bb.querySelector('[class*="upsell-template--"]');
      if(ups && ups.parentElement !== pf){
        var trustEl = pf.querySelector('.som-trust');
        var trustRow = trustEl ? trustEl.closest('.lightly-spaced-row') : null;
        var after = trustRow && trustRow.parentElement === pf ? trustRow : bb;
        pf.insertBefore(ups, after.nextSibling);
        ups.classList.add('som-upsell-moved');
      }
    });
  }

  /* ---------- Convertible Baby PJs: size lives in the pack chooser ---------- */

  /* Every tier in the pack chooser, Single PJ included, carries its own size picker,
     and the top Size selector only mirrors whatever the widget last set. It is
     redundant, so the stylesheet hides it and the size guide moves up onto the Fit
     row where it stays reachable. Verified: add to cart takes the widget's size. */
  function fitRow(){
    var pf = document.querySelector('.product-form[data-product-id="7831150854237"]');
    if(!pf) return;
    var opener = pf.querySelector('modal-opener[data-modal*="size-chart"]');
    if(!opener) return;
    var head = null;
    pf.querySelectorAll(':scope > .input-row').forEach(function(r){
      var st = r.querySelector('.lightly-spaced-row > strong');
      if(st && st.textContent.trim() === 'Fit') head = st.parentElement;
    });
    if(head && opener.parentElement !== head){
      head.classList.add('som-fit-head');
      head.appendChild(opener);
    }
  }

  /* ---------- new Pumper widget: make the expanded size list operable ----------
     The size picker is the app's own dropdown MENU. The stylesheet expands it into a row of
     buttons, but the app still thinks the menu is shut, so it keeps inert and
     aria-hidden="true" on the list. inert takes the whole subtree out of hit-testing and no
     stylesheet can override it, so the buttons were visible and dead. Measured on the v15
     draft: elementFromPoint over each button returned the parent, not the button.
     Stripping the two attributes (pointer-events is handled in the stylesheet) makes a real
     tap land, and also stops a screen reader from skipping the size choice entirely.
     Every write is conditional so a settled DOM produces no mutations. */
  function unlockSizes(){
    document.querySelectorAll('.pumper-bundles .pumper_dropdown_list').forEach(function(list){
      if(list.hasAttribute('inert')) list.removeAttribute('inert');
      if(list.getAttribute('aria-hidden') !== null) list.removeAttribute('aria-hidden');
      list.querySelectorAll('.pumper_dropdown_option').forEach(function(o){
        if(o.getAttribute('tabindex') === null) o.setAttribute('tabindex','0');
        var on = o.classList.contains('pumper_dropdown_option--active');
        if(o.getAttribute('aria-selected') !== String(on)) o.setAttribute('aria-selected', String(on));
      });
    });
  }

  /* Enter and Space pick a size, arrows move between them. Delegated on document so it
     survives the app re-rendering the list after every click. */
  var keysWired = false;
  function wireSizeKeys(){
    if(keysWired) return;
    keysWired = true;
    document.addEventListener('keydown', function(e){
      var o = e.target && e.target.closest && e.target.closest('.pumper-bundles .pumper_dropdown_option');
      if(!o) return;
      var k = e.key;
      if(k === 'Enter' || k === ' ' || k === 'Spacebar'){ e.preventDefault(); o.click(); return; }
      var next = null;
      if(k === 'ArrowRight' || k === 'ArrowDown') next = o.nextElementSibling;
      if(k === 'ArrowLeft'  || k === 'ArrowUp')   next = o.previousElementSibling;
      if(next && next.classList.contains('pumper_dropdown_option')){
        e.preventDefault();
        next.focus();
        next.click();
      }
    });
  }

  /* ---------- new Pumper widget: two properties the stylesheet cannot win ----------
     On the Convertible Baby PJs (template_9) the app beats even !important on the radio's
     border and on the gift title's white-space. Both were verified: an inline important
     property does take. So these two are set here rather than in the stylesheet.
     Everything else about that widget is plain CSS. */
  function polishNewWidget(){
    var root = document.querySelector('.pumper-bundles');
    if(!root) return;

    /* radio: solid navy with a centred tick when chosen, plain white ring when not.
       Left alone, the app paints a 3px white border that reads as a hollow ring. */
    root.querySelectorAll('input.pumper_pair').forEach(function(inp){
      var lab = inp.nextElementSibling;
      if(!lab) return;
      var r = lab.querySelector('[class*="cbmain--radio"]');
      if(!r) return;
      if(inp.checked){
        r.style.setProperty('border','2px solid #2E2A48','important');
        r.style.setProperty('background','#2E2A48','important');
      } else {
        r.style.setProperty('border','2px solid #6B6880','important');
        r.style.setProperty('background','#FFFFFF','important');
      }
    });

    /* gift title: the app sets white-space:nowrap, so the name ran under the FREE price.
       Allowing it to wrap puts it on two lines and keeps it clear of the price column. */
    root.querySelectorAll('.gift-title-text').forEach(function(t){
      t.style.setProperty('white-space','normal','important');
      t.style.setProperty('overflow','visible','important');
      t.style.setProperty('text-overflow','clip','important');
      t.style.setProperty('color','#1D1B2E','important');
    });

    /* put the radio, the pack name and the price on one line. The right column is a stack
       whose height differs per tier (the badged tier is taller), so the offset is measured
       rather than hard coded. */
    root.querySelectorAll('.pumper_template_9_label').forEach(function(lab){
      var left  = lab.querySelector('.pumper_template_9_block__cbmain--content--left');
      var name  = lab.querySelector('.pumper_template_9_block__cbmain--content--left__top') || left;
      var price = lab.querySelector('.pumper_totalAmount_wrapper');
      var radio = lab.querySelector('[class*="cbmain--radio"]');
      if(!left || !price || !name) return;
      left.style.removeProperty('margin-top');
      if(radio) radio.style.removeProperty('margin-top');
      var p = price.getBoundingClientRect(), n = name.getBoundingClientRect();
      if(!p.height || !n.height) return;
      var delta = Math.round((p.top + p.height/2) - (n.top + n.height/2));
      if(delta > 0){
        left.style.setProperty('margin-top', delta + 'px', 'important');
        if(radio) radio.style.setProperty('margin-top', delta + 'px', 'important');
      }
    });
  }

  /* ---------- boot ---------- */

  function apply(){
    skipSingle();
    placeBlocks();
    fitRow();
    mark();
    unlockSizes();
    polishNewWidget();
  }

  function start(){
    apply();
    wireSizeKeys();

    /* The new widget (Convertible Baby PJs) has no legacy container, so the old code fell
       through to a 400ms retry that never installed an observer. Watch whichever container
       this page has; the attribute filter is what catches the app putting inert back after
       a size is picked. */
    var w = document.querySelector(SEL9);
    if(w && !w.__somWatched){
      w.__somWatched = true;
      var t9 = null;
      new MutationObserver(function(){
        clearTimeout(t9);
        t9 = setTimeout(apply, 60);
      }).observe(w, {subtree:true, childList:true, characterData:true,
                     attributes:true, attributeFilter:['inert','aria-hidden','class']});
      setInterval(apply, 1000);
    }

    var c = document.querySelector(SEL);
    if(!c){ return setTimeout(start,400); }
    wireKeys(c);
    wireInstantPaint(c);

    /* The apps rewrite these nodes asynchronously after every click. An earlier
       version used a re-entrancy flag, which swallowed the app's own price update
       whenever it landed while the flag was set, leaving a stale "/each" on a pack
       that was showing its total. Instead: debounce and let it settle. Every write
       here is conditional, so once the DOM is right a pass writes nothing, produces
       no mutations, and the loop stops on its own. */
    var timer = null;
    function schedule(){
      clearTimeout(timer);
      timer = setTimeout(apply, 80);
    }
    new MutationObserver(schedule).observe(c,{subtree:true,childList:true,characterData:true});

    /* belt and braces: a slow tick so nothing can stay stale */
    setInterval(apply, 1000);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',start); } else { start(); }
})();
